import { render, staticRenderFns } from "./Movies.vue?vue&type=template&id=64bd3800&scoped=true"
import script from "./Movies.vue?vue&type=script&lang=js"
export * from "./Movies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bd3800",
  null
  
)

export default component.exports